/* import __COLOCATED_TEMPLATE__ from './invoice-table-row.hbs'; */
/* RESPONSIBLE TEAM: team-billing */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import safeWindowOpen from 'embercom/lib/safe-window-open';

export default class InvoiceTableRow extends Component {
  get canPayManually() {
    let { invoice } = this.args;
    return invoice.isOpen && invoice.isStripe;
  }

  @action
  openPaymentPage() {
    let { invoice } = this.args;
    safeWindowOpen(invoice.hostedInvoiceUrl, '_blank');
  }
}
